import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Customer } from '../../../models/customer.model';
import { Permission } from '../../../models/permission.model';
import { PrimengDropdown } from '../../../models/primeng-dropdown';
import { User } from '../../../models/user.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { fadeInOut } from '../../../services/animations';
import { UsersMappingService } from '../../../services/users-mapping.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'users-mapping',
    template: require('./users-mapping.component.html'),
    styles: [require('./users-mapping.component.css')],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.None
})

export class UsersMappingComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];
    user: User = new User;
    users: PrimengDropdown[];
    sourceUsersMapping: User[] = [];
    targetUsersMapping: User[] = [];
    mode: string = "Bijwerken";

    constructor(private usersMappingService: UsersMappingService, private router: Router,
        private activatedRoute: ActivatedRoute, private alertService: AlertService,
        private ngxLogger: NGXLogger, private accountService: AccountService) { }

    ngOnInit(): void {
        const id = this.activatedRoute.snapshot.params["id"];
        if (id) {
            this.mode = "Bijwerken";
            this.user.Id = id;
            this.getSourceUsersForMapping();
            this.getTargetUsersForMapping();
        }
        this.getUsers();
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    getUsers() {
        const getAllUsersSubscriber = this.usersMappingService.getAllUsers().subscribe((users: User[]) => {
            this.users = [];
            if (users != null && users.length > 0) {
                users.forEach((u: User) => {
                    this.users.push({ label: `${u.FullName} - ${u.Email}`, value: u.Id });
                });
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(getAllUsersSubscriber);
    }

    changeUserDropdown(event: any) {
        if (event && event.value && this.users) {
            this.user.FullName = this.users.find(f => f.value === event.value).label;
        }
        this.getSourceUsersForMapping();
        this.getTargetUsersForMapping();
    }

    // getById() {
    //     this.usersService.getById(this.user.Id).subscribe((res: User) => {
    //         this.user = res;
    //     }, error => {
    //         this.ngxLogger.error(error.message);
    //         throw error;
    //     });
    // }

    getSourceUsersForMapping() {
        this.sourceUsersMapping = [];
        const srcUserMpSubscriber = this.usersMappingService.getSourceUsersForMapping(this.user.Id).subscribe((sourceResponse: User[]) => {
            if (sourceResponse != null && sourceResponse.length > 0) {
                const sourceUsers = sourceResponse.filter(c => c.IsEnabled === true && c.IsDeleted === false);
                const userIds = sourceUsers.map(k => k.Id).toString();
                const getCustByUIdSubscriber = this.usersMappingService.getCustomersByUserId(userIds).subscribe((customer: Customer[]) => {
                    if (customer != null && customer.length > 0) {
                        this.sourceUsersMapping = sourceUsers.map(m => { m.Customer = new Customer; m.Customer.Company = customer.some(f => f.UserID !== null && f.UserID === m.Id) ? customer.find(f => f.UserID !== null && f.UserID === m.Id).Company : ''; return m; });
                        // sourceUsers.forEach(user => {
                        //     user.Customer = new Customer;
                        //     user.Customer.Company = customer.some(f => f.UserID !== null && f.UserID === user.Id) ? customer.find(f => f.UserID !== null && f.UserID === user.Id).Company : '';
                        // });
                        // this.sourceUsersMapping = sourceUsers;
                    } else {
                        this.sourceUsersMapping = sourceUsers;
                    }
                }, er => {
                    this.sourceUsersMapping = sourceUsers;
                });
                this.subscribers.push(getCustByUIdSubscriber);
            } else {
                this.sourceUsersMapping = [];
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(srcUserMpSubscriber);
    }

    getTargetUsersForMapping() {
        this.targetUsersMapping = [];
        const trgUserMpSubscriber = this.usersMappingService.getTargetUsersForMapping(this.user.Id).subscribe((targetReponse: User[]) => {
            if (targetReponse != null && targetReponse.length > 0) {
                const targetUsers = targetReponse.filter(c => c.IsEnabled === true && c.IsDeleted === false);
                const userIds = targetUsers.map(k => k.Id).toString();
                const getCustomerbyUIdSubscriber = this.usersMappingService.getCustomersByUserId(userIds).subscribe((customer: Customer[]) => {
                    if (customer != null && customer.length > 0) {
                        this.targetUsersMapping = targetUsers.map(m => { m.Customer = new Customer; m.Customer.Company = customer.some(f => f.UserID !== null && f.UserID === m.Id) ? customer.find(f => f.UserID !== null && f.UserID === m.Id).Company : ''; return m; });
                        // targetUsers.forEach(user => {
                        //     user.Customer = new Customer;
                        //     user.Customer.Company = customer.some(f => f.UserID !== null && f.UserID === user.Id) ? customer.find(f => f.UserID !== null && f.UserID === user.Id).Company : '';
                        // });
                        // this.targetUsersMapping = targetUsers;
                    } else {
                        this.targetUsersMapping = targetUsers;
                    }
                    this.subscribers.push(getCustomerbyUIdSubscriber);
                }, er => {
                    this.targetUsersMapping = targetUsers;
                });
            } else {
                this.targetUsersMapping = [];
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(trgUserMpSubscriber);
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    updateUserMappingGroup() {
        if (this.caneditUsersMappingPermission) {
            if (this.targetUsersMapping.length > 0) {
                const upGRpSubscriber = this.usersMappingService.updateUserMappingGroup(this.user.Id, this.targetUsersMapping).subscribe((res: User[]) => {
                    this.alertService.showMessage('Link gebruiker aan gebruiker', 'Link gebruiker aan gebruiker succesvol opgeslagen!', MessageSeverity.success);
                }, error => {
                    this.ngxLogger.error(error.message);
                    throw error;
                });
                this.subscribers.push(upGRpSubscriber);
            } else {
                this.alertService.showMessage('Link gebruiker aan gebruiker', 'Selecteer ten minste één klant!', MessageSeverity.error);
            }

        } else {
            this.alertService.showMessage('Link gebruiker aan gebruiker', 'U bent niet gemachtigd om records te bewerken!', MessageSeverity.warn);
        }
    }

    get canmanageUsersMappingPermission() {
        return this.accountService.userHasPermission(Permission.manageUsersMappingPermission);
    }

    get canviewUsersMappingPermission() {
        return this.accountService.userHasPermission(Permission.viewUsersMappingPermission);
    }

    get caneditUsersMappingPermission() {
        return this.accountService.userHasPermission(Permission.editUsersMappingPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/users/users-mapping/users-mapping.component.ts